// extracted by mini-css-extract-plugin
module.exports = {"linkarrow":"bo9kA","wrapper":"wUQlY","lifestyle_wrapper":"hxXn_"};